import { onboardingPartnerTerritoryApi } from '../classes/services/api/OnboardingPartnerTerritoryApi'

class PartnerTerritoryService {
  public fetchPartnerTerritory = () => {
    return onboardingPartnerTerritoryApi.getPartnerTerritory()
  }
}

export const partnerTerritoryService = new PartnerTerritoryService()
